import { useNavigate, createFileRoute } from '@tanstack/react-router'
import RazorpayCheckout, { type BookingDetails } from '@/components/custom/ui/clients/tempula/payment/razorpay'
import type { PaymentSuccessData } from '@/hooks/useRazorpay'
import type { ReceiptData } from '@/components/custom/ui/clients/tempula/payment/receipt'
import { tempulaPaymentConfig, tempulaPaymentService } from '@/constant/config/clients/tempula/payment/paymentConfig'

export const Route = createFileRoute('/_clients/tempula/razorPay')({
  component: RouteComponent,
})

function randomBookingDates() {
  const fmt = (d: Date) => d.toISOString().split("T")[0];
  const checkIn = new Date();
  checkIn.setDate(checkIn.getDate() + Math.floor(Math.random() * 335) + 30);
  const checkOut = new Date(checkIn);
  checkOut.setDate(checkOut.getDate() + Math.floor(Math.random() * 7) + 1);
  return { checkIn: fmt(checkIn), checkOut: fmt(checkOut) };
}

const { checkIn, checkOut } = randomBookingDates();
const nights = Math.ceil((new Date(checkOut).getTime() - new Date(checkIn).getTime()) / (1000 * 60 * 60 * 24));

const mockBooking: BookingDetails = {
  roomIds: ["tempula-dh-001"],
  roomName: "Dhuppi Room",
  name: "John Doe",
  guestTitle: "Mr",
  guestFirstName: "John",
  guestLastName: "Doe",
  email: "john@example.com",
  phone: "9876543210",
  guestAddress: "123 Test Street",
  guestState: "West Bengal",
  guestCountry: "India",
  guestPincode: "700001",
  checkIn,
  checkOut,
  nights,
  adults: 2,
  children: 0,
  infants: 0,
  petsAllowed: false,
  petsCount: 0,
  foodAllowed: false,
  rooms: [{ name: "Dhuppi Room", qty: 1, pricePerNight: 3499, subtotal: 3499 * nights }],
  extraAdultCost: 0,
  extraChildrenCost: 0,
  foodCost: 0,
  foodPeople: 2,
  amount: 3499 * nights,
  notes: "Late check-in",
}

function RouteComponent() {
  const navigate = useNavigate();

  const handleSuccess = (payment: PaymentSuccessData) => {
    const receipt: ReceiptData = {
      ...payment,
      roomName: mockBooking.roomName,
      checkIn: mockBooking.checkIn,
      checkOut: mockBooking.checkOut,
      guests: mockBooking.adults + mockBooking.children + mockBooking.infants,
      paidAt: new Date().toISOString(),
    };
    sessionStorage.setItem("receipt", JSON.stringify(receipt));
    navigate({ to: "/tempula/receipt" });
  };

  return (
    <RazorpayCheckout
      booking={mockBooking}
      config={tempulaPaymentConfig}
      service={tempulaPaymentService}
      onSuccess={handleSuccess}
    />
  );
}
